import type { ICompanyNote } from './../types/note/models'
import { makeNoteService } from '~/cynqueModules/factoriesForServices/notes'

export const {
  createNote: createCompanyNote,
  updateNote: updateCompanyNote,
  deleteNote: deleteCompanyNote,
} = makeNoteService<ICompanyNote>('/api/companynotes', 'companyNote')
